module.exports = __webpack_public_path__ + "img/no-view.253fc2a2.svg";